import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import moment from 'moment';

interface PublishShiftsModalProps {
	workplaceId: number;
	initialStartDate: string;
	initialEndDate: string;
	onPublish: (startDate: string, endDate: string) => void;
	onClose: () => void;
}

const PublishShiftsModal: React.FC<PublishShiftsModalProps> = ({
	workplaceId: _workplaceId,
	initialStartDate,
	initialEndDate,
	onPublish,
	onClose,
}) => {
	const formatDateForDisplay = (dateStr: string) => {
		if (!dateStr) return '';
		const date = moment(dateStr);
		return date.isValid() ? date.format('MMMM D, YYYY') : '';
	};

	const handleConfirm = () => {
		// Convert dates to YYYY-MM-DD format for the API
		const startDate = moment(initialStartDate).format('YYYY-MM-DD');
		// Add 1 day to the end date
		const endDate = moment(initialEndDate).add(1, 'day').format('YYYY-MM-DD');
		onPublish(startDate, endDate);
	};

	return (
		<Box
			sx={{
				position: 'fixed',
				top: 0,
				left: 0,
				right: 0,
				bottom: 0,
				backgroundColor: 'rgba(0, 0, 0, 0.5)',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
				zIndex: 9999,
			}}
			onClick={onClose}
		>
			<Paper
				onClick={(e) => e.stopPropagation()}
				sx={{
					width: '90%',
					maxWidth: '500px',
					padding: '32px',
					borderRadius: '8px',
				}}
			>
				<Typography
					variant="h5"
					sx={{
						marginBottom: '24px',
						fontFamily: 'Gotham, sans-serif',
						fontWeight: 500,
						color: 'rgb(68, 99, 136)',
					}}
				>
					Publish Schedule
				</Typography>

				<Typography
					sx={{
						marginBottom: '32px',
						fontSize: '16px',
						fontFamily: 'Gotham, sans-serif',
						color: '#333',
						lineHeight: 1.6,
					}}
				>
					Are you sure you want to publish the schedule for the week starting{' '}
					<strong>{formatDateForDisplay(initialStartDate)}</strong>?
				</Typography>

				<Typography
					sx={{
						marginBottom: '32px',
						fontSize: '14px',
						fontFamily: 'Gotham, sans-serif',
						color: '#666',
					}}
				>
					All draft shifts between {formatDateForDisplay(initialStartDate)} and{' '}
					{formatDateForDisplay(initialEndDate)} will be published and become visible to other users.
				</Typography>

				<Box sx={{ display: 'flex', gap: '12px', justifyContent: 'flex-end' }}>
					<button
						type="button"
						onClick={onClose}
						style={{
							backgroundColor: '#f5f5f5',
							color: '#333',
							border: 'none',
							borderRadius: '6px',
							padding: '0 24px',
							height: '32px',
							fontFamily: 'Gotham, sans-serif',
							fontSize: '14px',
							cursor: 'pointer',
							fontWeight: 500,
						}}
					>
						Cancel
					</button>
					<button
						type="button"
						onClick={handleConfirm}
						style={{
							backgroundColor: 'rgb(68, 99, 136)',
							color: 'white',
							border: 'none',
							borderRadius: '6px',
							padding: '0 24px',
							height: '32px',
							fontFamily: 'Gotham, sans-serif',
							fontSize: '14px',
							cursor: 'pointer',
							fontWeight: 500,
						}}
						onMouseEnter={(e) => {
							e.currentTarget.style.backgroundColor = 'rgb(57, 80, 111)';
						}}
						onMouseLeave={(e) => {
							e.currentTarget.style.backgroundColor = 'rgb(68, 99, 136)';
						}}
					>
						Confirm
					</button>
				</Box>
			</Paper>
		</Box>
	);
};

export default PublishShiftsModal;
